const en_facility_list = {

}

export default en_facility_list;